import { create } from "zustand";

const useToasterStore = create((set) => ({
  toasterOpen: false,
  alertType: "success",
  message: "",
  openToaster: (alertType, message) =>
    set({ toasterOpen: true, alertType, message }),
  closeToaster: (payload) => set({ toasterOpen: false }),
}));

export default useToasterStore;

// const useToasterStore = create((set) => {
//   const windowInnerWidth = window.innerWidth;

//   return {
//     toaster: {
//       toasterOpen: false,
//       alertType: "success",
//       message: "",
//       vertical: "top",
//       horizontal: "right",
//     },

//     openToaster: (alertType, message) => {
//       const isNotDesktop = windowInnerWidth < 1024;
//       set((state) => ({
//         toaster: {
//           ...state.toaster,
//           toasterOpen: true,
//           alertType,
//           message,
//           vertical: isNotDesktop ? "bottom" : "top",
//           horizontal: isNotDesktop ? "center" : "right",
//         },
//       }));
//     },

//     closeToaster: () => {
//       set((state) => ({ toaster: { ...state.toaster, toasterOpen: false } }));
//     },
//   };
// });

// export default useToasterStore;
